import React, { useState, useEffect, useRef } from "react";
import CalendarSelector from "./Components/CalendarSelector";
import "./Components/CalendarSelector.css";
import "./BookingPage.css";
// TimeSelector custom: mostra orari cliccabili in blu
function TimeSelector({ times, value, onChange }) {
  return (
    <div style={{display:'flex',gap:10,flexWrap:'wrap',justifyContent:'center',marginTop:10}}>
      {times.length === 0 ? (
        <span style={{color:'#aaa'}}>Nessun orario disponibile</span>
      ) : (
        times.map(t => (
          <button
            key={t}
            type="button"
            className="btn"
            style={{
              background: value === t ? '#007bff' : '#00bfff',
              color: value === t ? '#fff' : '#0a192f',
              border: value === t ? '2px solid #007bff' : '2px solid #00bfff',
              fontWeight: 600,
              minWidth: 80,
              marginBottom: 5,
              boxShadow: value === t ? '0 0 8px #007bff55' : 'none'
            }}
            onClick={() => onChange(t)}
          >
            {t}
          </button>
        ))
      )}
    </div>
  );
}

// Simulazione: orari disponibili per ogni servizio e giorno
const services = [
  {
    id: 1,
    name: "Mario Rossi",
    role: "Consulenza Aziendale",
    slots: {
      "2025-09-25": ["09:00", "10:00", "11:00"],
      "2025-09-26": ["10:30", "12:00"],
      "2025-09-27": ["09:00", "11:30"]
    }
  },
  {
    id: 2,
    name: "Luisa Bianchi",
    role: "Supporto Tecnico",
    slots: {
      "2025-09-28": ["14:00", "15:30"],
      "2025-09-29": ["09:00", "10:00"]
    }
  },
  {
    id: 3,
    name: "Giovanni Verdi",
    role: "Sviluppo Software",
    slots: {
      "2025-09-30": ["16:00", "17:00"],
      "2025-10-01": ["09:00", "10:30", "12:00"]
    }
  }
];

function BookingPage() {
  const [selectedService, setSelectedService] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null); // Date object
  const [selectedTime, setSelectedTime] = useState("");
  const [form, setForm] = useState({ nome: "", cognome: "", telefono: "", email: "" });
  const [formTouched, setFormTouched] = useState({});

  const canvasRef = useRef(null);
  const particles = useRef([]);

  const handleCardClick = (service) => {
    setSelectedService(service);
    setSelectedDate(null);
    setSelectedTime("");
    setForm({ nome: "", cognome: "", telefono: "", email: "" });
    setFormTouched({});
  };

  const closeModal = () => setSelectedService(null);

  const isFormValid = () => {
    return (
      form.nome.trim() &&
      form.cognome.trim() &&
      form.telefono.trim() &&
      form.email.trim() &&
      /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(form.email)
    );
  };

  const handleBooking = () => {
    if (!selectedDate || !selectedTime || !isFormValid()) return;
    const dateStr = selectedDate.toLocaleDateString('it-IT');
    alert(`Prenotazione effettuata per ${form.nome} ${form.cognome} (${form.telefono}, ${form.email}) con ${selectedService.name} il ${dateStr} alle ${selectedTime}`);
    closeModal();
  };

  // ====================
  // Particles Background
  // ====================
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    let width = canvas.width = window.innerWidth;
    let height = canvas.height = window.innerHeight;

    function resize() {
      width = canvas.width = window.innerWidth;
      height = canvas.height = window.innerHeight;
    }
    window.addEventListener("resize", resize);

    // Initialize particles
    const numParticles = 80;
    particles.current = Array.from({ length: numParticles }, () => ({
      x: Math.random() * width,
      y: Math.random() * height,
      radius: Math.random() * 2 + 1,
      speedX: (Math.random() - 0.5) * 0.5,
      speedY: (Math.random() - 0.5) * 0.5,
      color: `rgba(255,255,255,${Math.random() * 0.5 + 0.3})`
    }));

    function animate() {
      ctx.clearRect(0, 0, width, height);
      particles.current.forEach(p => {
        p.x += p.speedX;
        p.y += p.speedY;

        if (p.x < 0) p.x = width;
        if (p.x > width) p.x = 0;
        if (p.y < 0) p.y = height;
        if (p.y > height) p.y = 0;

        ctx.beginPath();
        ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
        ctx.fillStyle = p.color;
        ctx.fill();
      });
      requestAnimationFrame(animate);
    }

    animate();
    return () => window.removeEventListener("resize", resize);
  }, []);

  return (
    <div className="booking-page">
      <canvas ref={canvasRef} className="particles-canvas"></canvas>

      {/* Header */}
      <header className="header">
        <div className="logo">
          <img src="logo.png" alt="MA Software Logo" />
          <span>MA Software</span>
        </div>
        <a href="/" className="menu-btn">Home</a>
      </header>

      {/* Main Content */}
      <main className="booking-main">
        <h1>Web App Prenotazioni</h1>
        <p>Seleziona un servizio o una persona per prenotare un appuntamento:</p>

        {/* Cards */}
        <section className="services-cards">
          {services.map((service) => (
            <div
              key={service.id}
              className="service-card"
              onClick={() => handleCardClick(service)}
            >
              <img
                src={`https://avatars.dicebear.com/api/micah/${encodeURIComponent(service.name)}.svg`}
                alt={service.name}
                className="service-avatar"
              />
              <h3>{service.name}</h3>
              <p className="role">{service.role}</p>
            </div>
          ))}
        </section>
      </main>

      {/* Modal prenotazione con calendario e ora */}
      {selectedService && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <h2>{selectedService.name} - {selectedService.role}</h2>
            <CalendarSelector
              value={selectedDate}
              onChange={date => {
                setSelectedDate(date);
                setSelectedTime("");
              }}
              tileDisabled={({ date }) => {
                // Disabilita i giorni senza slot disponibili
                if (!selectedService) return true;
                const d = date.toISOString().split('T')[0];
                return !selectedService.slots[d] || selectedService.slots[d].length === 0;
              }}
              tileClassName={({ date }) => {
                if (!selectedService) return '';
                const d = date.toISOString().split('T')[0];
                if (selectedService.slots[d] && selectedService.slots[d].length > 0) {
                  return 'calendar-available-day';
                }
                return '';
              }}
            />
            {/* Mostra orari disponibili per la data selezionata */}
            {selectedDate && (
              <>
                <TimeSelector
                  times={
                    selectedService.slots[
                      selectedDate.toISOString().split('T')[0]
                    ] || []
                  }
                  value={selectedTime}
                  onChange={setSelectedTime}
                />
                {/* Form dati utente */}
                <form className="booking-user-form" style={{marginTop:20, display:'flex', flexDirection:'column', gap:12}} onSubmit={e => {e.preventDefault(); handleBooking();}}>
                  <input
                    type="text"
                    placeholder="Nome*"
                    value={form.nome}
                    onChange={e => setForm(f => ({...f, nome: e.target.value}))}
                    onBlur={() => setFormTouched(t => ({...t, nome:true}))}
                    required
                  />
                  <input
                    type="text"
                    placeholder="Cognome*"
                    value={form.cognome}
                    onChange={e => setForm(f => ({...f, cognome: e.target.value}))}
                    onBlur={() => setFormTouched(t => ({...t, cognome:true}))}
                    required
                  />
                  <input
                    type="tel"
                    placeholder="Telefono*"
                    value={form.telefono}
                    onChange={e => setForm(f => ({...f, telefono: e.target.value}))}
                    onBlur={() => setFormTouched(t => ({...t, telefono:true}))}
                    required
                  />
                  <input
                    type="email"
                    placeholder="Email*"
                    value={form.email}
                    onChange={e => setForm(f => ({...f, email: e.target.value}))}
                    onBlur={() => setFormTouched(t => ({...t, email:true}))}
                    required
                  />
                  {/* Messaggi di errore semplici */}
                  <div style={{color:'#ff4d4f', fontSize:'0.95em', minHeight:22}}>
                    {formTouched.nome && !form.nome.trim() && 'Il nome è obbligatorio.'}
                    {formTouched.cognome && !form.cognome.trim() && ' Il cognome è obbligatorio.'}
                    {formTouched.telefono && !form.telefono.trim() && ' Il telefono è obbligatorio.'}
                    {formTouched.email && (!form.email.trim() ? ' L’email è obbligatoria.' : !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(form.email) ? ' Email non valida.' : '')}
                  </div>
                </form>
              </>
            )}
            <div className="modal-buttons">
              <button className="btn secondary-btn" onClick={closeModal}>Chiudi</button>
              <button
                className="btn primary-btn"
                onClick={handleBooking}
                disabled={!selectedDate || !selectedTime || !isFormValid()}
                type="submit"
              >
                Prenota
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Footer */}
      <footer className="footer">
        <p>© 2025 MA Software - Tutti i diritti riservati</p>
      </footer>
    </div>
  );
}

export default BookingPage;

